import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import Grid from 'components/core/Grid';
import Typography from 'components/core/Typography';
import Stack from 'components/core/Stack';
import IconButton from 'components/core/IconButton';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import CommonUtils from 'utils/CommonUtils';

const InfoLine = ({id, label, value, link, dateSpecificity}) => {
    const navigate = useNavigate();
    
    let displayValue = value || '';
    let displayLink = link;
    
    if (value instanceof Date) {
        displayValue = CommonUtils.formatDate(value, dateSpecificity || 'yyyy-mm-dd');
    } else if (value && typeof value === 'object' && typeof value.get === 'function') {
        if (id === 'observedBy' || id === 'reviewedBy' || id === 'voucherSource') {
            const person = value.get('person') || value;
            displayValue = `${person.get('firstName') || ''} ${person.get('lastName') || ''}`.trim();
        } else if (id === 'subject') {
            displayValue = `${value.get('label')} (${value.get('shortCode')})`;
        } else if (value.get('label')) {
            displayValue = value.get('label');
        } else if (value.get('name')) {
            displayValue = value.get('name');
        } else if (value.get('primaryName')) {
            displayValue = value.get('primaryName');
        } else if (value.get('location')) {
            displayValue = value.get('name');
        }
        
        if (!displayLink) {
            if ((id === 'location' || id === 'parent') && value.id) {
                displayLink = `/location/${value.id}`;
            } else if (id === 'event' && value.id) {
                displayLink = `/event/${value.id}`;
            }
        }
    } else if (value === 'None' || value === '') {
        displayValue = 'None';
    }

    
    if (displayValue && typeof displayValue === 'object' && displayValue.className && displayValue.id) {
        displayValue = '';
    }
    
    return (
        <Grid item xs={6} id={id}>
            <Stack sx={{mb: 2}}>
                <Typography variant='body2'>
                    {label}
                </Typography>
                {displayLink ? (
                    <Stack direction="row" alignItems="center">
                        <Typography variant='body1' sx={{ mr: 1 }}>
                            {displayValue}
                        </Typography>
                        <IconButton size="sm" onClick={() => navigate(displayLink)}>
                            <ArrowOutwardIcon fontSize="small" />
                        </IconButton>
                    </Stack>
                ) : (
                    <Typography variant='body1'>
                        {displayValue}
                    </Typography>
                )}
            </Stack>
        </Grid>
    )
}

export default InfoLine;